<template>
  <div class="p-3">
    <div>
      <h1 id="page3">{{translate('Log.text0')}}</h1>
      <simulation-banner v-if="!scenarioSelected"></simulation-banner>
    </div>
    <userBar></userBar>

    {{translate('Log.text1')}}: 
    <span v-if="averageDelayBetweenEventWriteAndCrewAssignInSeconds"><strong>{{this.formatNumber(averageDelayBetweenEventWriteAndCrewAssignInSeconds)}}</strong> {{translate('Log.seconds')}}</span>
    <span v-else>{{translate('Log.notYetAvailable')}}</span>
    <br />

    {{translate('Log.text2')}}:
    <span v-if="averageAssignedCrewArriveToEventInSeconds"><strong>{{this.formatNumber(averageAssignedCrewArriveToEventInSeconds)}}</strong> {{translate('Log.seconds')}}</span>
    <span v-else>{{translate('Log.notYetAvailable')}}</span>


    <br /><br /><br /><h1><a href="#" style="color:red;" @click.stop.prevent="setSelectedEntity([7,8,9])">Test</a></h1>
    <br /><br /><br /><h1><a href="#" style="color:red;" @click.stop.prevent="clearSelectedEntity()">Clear</a></h1>


  </div>
</template>

<script>
  import userBar from '@/components/userBar.vue';
  import simulationBanner from "../components/simulationBanner";
  import { mapActions } from 'vuex';
  export default {
    name: "Log",
    components:{
      userBar,
      simulationBanner
    },
    methods: {
      round(value, precision){
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
      },
      formatNumber(value) {
          return value.toString().replace(".", ',');
      },
      async setSelectedEntity(entityIds) {
        await this.sendCommand({cmd: 'setSelectedEntities', payload: {entityIds}});
      },
      async clearSelectedEntity() {
        await this.sendCommand({cmd: 'clearSelectedEntities'});
      },
      ...mapActions(['sendCommand']),
    },
    computed: {
      averageDelayBetweenEventWriteAndCrewAssignInSeconds(){
        return this.round(this.$store.state.simulation.evaluation.averageDelayBetweenEventWriteAndCrewAssignInSeconds, 1)
      },
      averageAssignedCrewArriveToEventInSeconds(){
        return this.round(this.$store.state.simulation.evaluation.averageAssignedCrewArriveToEventInSeconds, 1)
      },
      scenarioSelected() {
        return this.$store.state.scenarioSelected;
      },
      simulationEvaluation() {
          return this.$store.state.simulation.evaluation;
      }
    }
  }
</script>
